import { configurationPageClass } from '@modules/configuration/components/configurationLayout';
import { useTranslation } from 'react-i18next';
import { useSuscription } from '../../hooks/useSuscription';
import { Plan, Features, Faq } from '../display';
import { PlanSkeleton, FeaturesSkeleton, FaqSkeleton } from '../skeletons';
import { useEffect } from 'react';
import { useToast } from '@shared/hooks/use-toast';

export const Main = () => {
  const { t } = useTranslation('suscriptionModule');
  const { stripePortalUrl, isLoading, error } = useSuscription();
  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      let errorMessage = t('error.title');
      if (
        typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        (error as any).response?.data?.message
      ) {
        errorMessage = (error as any).response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      toast({
        title: t('error.title'),
        description: errorMessage,
        duration: 4000,
      });
    }
    // Solo cuando cambia error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <div className={configurationPageClass}>
      {/* Contenido principal */}
      {isLoading ? (
        <>
          <PlanSkeleton />
          <FeaturesSkeleton />
          <FaqSkeleton />
        </>
      ) : (
        <>
          <Plan stripePortalUrl={stripePortalUrl} isLoadingStripe={isLoading} />
          <Features />
          <Faq />
        </>
      )}
    </div>
  );
};
